import React from 'react';
import { useTranslation } from 'react-i18next';

import './loader.style.scss';
import PropTypes from 'prop-types';

function Loader({ text }) {
  const { t } = useTranslation();
  const displayText = text ?? t('loaders.defaultLoadingText');
  return (
    <div className="lds-container">
      <div className="lds-default">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className="text-center" style={{ margin: '20px 0' }}>
        {' '}
        {displayText}{' '}
      </div>
    </div>
  );
}

Loader.propTypes = {
  text: PropTypes.string,
};

export default Loader;
